import { del, get, post, put } from "../lib/axios-client";
import * as url from "../lib/url_helper";
import { parseApiError } from "../utils/api_error";

const cleanParams = (params) => {
  return Object.fromEntries(
    Object.entries(params).filter(
      ([_, value]) => value !== undefined && value !== null && value !== "",
    ),
  );
};

export const getProductsApi = async (params = {}) => {
  try {
    const response = await get(url.GET_PRODUCTS, {
      params: cleanParams(params),
    });
    return response.data;
  } catch (error) {
    const message = parseApiError(error);
    throw message;
  }
};

export const getBrandsApi = async (params = {}) => {
  try {
    const response = await get(url.GET_BRANDS, {
      params: cleanParams(params),
    });
    return response.data;
  } catch (error) {
    const message = parseApiError(error);
    throw message;
  }
};

export const getbannersApi = async (params = {}) => {
  try {
    const response = await get(url.GET_BANNERS, {
      params: cleanParams(params),
    });
    return response.data;
  } catch (error) {
    const message = parseApiError(error);
    throw message;
  }
};

export const getProductDetailsApi = async (id) => {
  try {
    const response = await get(`${url.GET_PRODUCTS}/${id}`);
    return response.data;
  } catch (error) {
    const message = parseApiError(error);
    throw message;
  }
};

export const getProductByCategoryApi = async (categoryName) => {
  try {
    const response = await get(
      `${url.GET_PRODUCTS_BY_CATEGORIES}/${categoryName}`,
      {
        params: {
          pageIndex: 0,
          pageSize: 20,
        },
      },
    );
    return response.data;
  } catch (error) {
    const message = parseApiError(error);
    throw message;
  }
};

export const getCategoriesApi = async () => {
  try {
    const response = await get(url.GET_CATEGORIES);
    return response.data;
  } catch (error) {
    const message = parseApiError(error);
    throw message;
  }
};

export const getCategoriesHierachyApi = async () => {
  try {
    const response = await get(url.GET_CATEGORIES_HIERACHY);
    return response.data;
  } catch (error) {
    const message = parseApiError(error);
    throw message;
  }
};

export const basketCheckoutApi = async (data) => {
  try {
    const response = await post(url.BASKET_CHECKOUT, data);
    return response.data;
  } catch (error) {
    const message = parseApiError(error);
    throw message;
  }
};

export const getItemInBasketApi = async () => {
  try {
    const response = await get(url.GET_BASKET);
    return response.data;
  } catch (error) {
    const message = parseApiError(error);
    throw message;
  }
};

export const addItemToBasketApi = async (data) => {
  try {
    const formData = new FormData();

    formData.append("ProductId", data.id);
    formData.append("Quantity", data.quantity);
    formData.append("PrescriptionFile", data?.PrescriptionFile);
    formData.append("PrescriptionNotes", data?.PrescriptionNotes);
    formData.append("Phone", data?.phone);
    formData.append(
      "ExistingPrescriptionUrl",
      localStorage.getItem("ExistingPrescriptionUrl"),
    );

    // Object.keys(data).forEach((key) => {
    //   formData.append(key, data[key]);
    // });

    const response = await post(url.ADD_BASKET, formData, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    localStorage.setItem(
      "ExistingPrescriptionUrl",
      response?.data?.prescriptionFileUrl,
    );
    return response.data;
  } catch (error) {
    const message = parseApiError(error);
    throw message;
  }
};

export const updateItemToBasketApi = async (data) => {
  try {
    const response = await put(url.ADD_BASKET, data);
    return response.data;
  } catch (error) {
    const message = parseApiError(error);
    throw message;
  }
};

export const removeItemFromBasketApi = async (id) => {
  try {
    const response = await del(`${url.REMOVE_ITEM_BASKET}/${id}`);
    return response.data;
  } catch (error) {
    const message = parseApiError(error);
    throw message;
  }
};

export const getOrdersApi = async ({ pageIndex = 0, pageSize = 20, id }) => {
  try {
    const response = await get(`${url.GET_ORDERS}/${id}`, {
      params: {
        pageIndex,
        pageSize,
      },
    });
    return response.data;
  } catch (error) {
    const message = parseApiError(error);
    throw message;
  }
};

export const getOrdersByIDApi = async (id) => {
  try {
    const response = await get(`${url.GET_ORDER_DETAILS}/${id}`);
    return response.data;
  } catch (error) {
    const message = parseApiError(error);
    throw message;
  }
};

export const getLocationsApi = async ({
  latitude = null,
  longitude = null,
}) => {
  try {
    const response = await get(url.GET_LOCATIONS, {
      params: {
        latitude,
        longitude,
      },
    });
    return response.data;
  } catch (error) {
    const message = parseApiError(error);
    throw message;
  }
};

export const initiatePaymentApi = async (id) => {
  try {
    const response = await post(
      `${url.POST_INITIATE_PAYMENT}/${id}/payments/initiate`,
      {},
    );
    return response.data;
  } catch (error) {
    const message = parseApiError(error);
    throw message;
  }
};

export const getStoresLocationsApi = async ({
  userLat = null,
  userLng = null,
}) => {
  try {
    const response = await get(url.GET_STORES, {
      params: {
        userLat,
        userLng,
      },
    });
    return response.data;
  } catch (error) {
    const message = parseApiError(error);
    throw message;
  }
};

function handlePhoneFormat(phone) {
  if (!phone) return "";
  if (phone.startsWith("0")) {
    return `254${phone.slice(1)}`;
  }
  if (phone.startsWith("+")) {
    return phone.slice(1);
  }
  return phone;
}

export const submitPrescription = async (data) => {
  try {
    const formData = new FormData();

    formData.append("CellphoneNumber", handlePhoneFormat(data.Phone));
    formData.append("Email", data.Email);
    formData.append("DocumentFile", data?.PrescriptionFile);
    formData.append("FullName", data?.Username);
    // formData.append("Notes", data?.Notes);
    //
    formData.append("CustomerId", data?.CustomerId);
    formData.append(
      "NationalIdOrPatientNumber",
      data?.NationalIdOrPatientNumber,
    );
    formData.append("InsuranceNumber", data?.InsuranceNumber);
    formData.append(
      "PatientDateOfBirth",
      new Intl.DateTimeFormat("fr-CA", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      }).format(new Date(data?.PatientDateOfBirth)),
    );
    formData.append("Channel", data?.Channel);
    formData.append("VerificationCode", data?.VerificationCode);
    formData.append("DoctorName", data?.DoctorName);
    formData.append("DoctorId", data?.DoctorId);
    formData.append(
      "IssueDate",
      new Intl.DateTimeFormat("fr-CA", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      }).format(new Date(data?.IssueDate)),
    );
    formData.append(
      "ExpiryDate",
      new Intl.DateTimeFormat("fr-CA", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      }).format(new Date(data?.ExpiryDate)),
    );

    // Object.keys(data).forEach((key) => {
    //   formData.append(key, data[key]);
    // });

    const response = await post(url.SUBMIT_PRESCRIPTION, formData, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    return response.data;
  } catch (error) {
    const message = parseApiError(error);
    throw message;
  }
};

export const requestOTP = async (data) => {
  try {
    const response = await post(`/prescriptions/request-otp`, {
      email: data?.email,
      cellphoneNumber: data?.cellphoneNumber,
      channel: data?.channel,
    });
    return response.data;
  } catch (error) {
    const message = parseApiError(error);
    throw message;
  }
};

export const approvedPrescriptions = async (params = {}) => {
  try {
    const response = await get(`/prescriptions/wallet`, {
      params: cleanParams(params),
    });
    return response.data;
  } catch (error) {
    const message = parseApiError(error);
    throw message;
  }
};
